import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AvatarPill({
  companyAvatar,
  companyName,
  children
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "full",
    paddingInline: "200",
    paddingBlock: "50",
    backgroundColor: "fill-surface-default",
    borderWidth: "100",
    borderStyle: "solid",
    borderColor: "border-tertiary-default",
    "data-test-id": "deal-plan-avatars-pill",
    children: [companyAvatar, companyName ? /*#__PURE__*/_jsx(View, {
      minInlineSize: "0",
      maxInlineSize: "120px",
      paddingInline: "100",
      children: /*#__PURE__*/_jsx(Text, {
        as: "div",
        typography: "detail-100",
        marginInlineEnd: "200",
        children: /*#__PURE__*/_jsx(TruncateString, {
          matchContentWidth: true,
          maxWidth: 120,
          children: companyName
        })
      })
    }) : null, children]
  });
}